import request from '@/utils/request'
import qs from 'qs'

export function login(params) {
    return request({
        url: '/login/loginByName',
        method: 'post',
        data: qs.stringify(params)
    })
}


export function outLogin() {
    return request({
        url: '/login/outLogin',
        method: 'post',
        data: qs.stringify(params)
    })
}